import { connect } from 'react-redux'
import { SubmitForm as component } from './submitForm'
import * as actions from './actions'
import { RootState } from 'stores/index'
import { submit } from 'components/main/actions'
import {
  getCompleteness,
  getFirebaseErrorCode,
  getSelectedAnswers,
  getSubmissionStatus
} from 'lib/selectors'

const mapStateToProps = (state: RootState) => ({
  ...state.form,
  isComplete: getCompleteness(state),
  submissionStatus: getSubmissionStatus(state),
  firebaseErrorCode: getFirebaseErrorCode(state),
  selectedAnswers: getSelectedAnswers(state)
})
export const SubmitForm = connect(
  mapStateToProps,
  { ...actions, submit }
)(component)
